import styled from 'styled-components';

const SelectedCountryWrapper = styled.div`
  height: 40px;
  line-height: 40px;
  padding-left: 10px;
  border-color: #000000;
  border-width: 1px;
  border-bottom-style: ${({ isExpanded }) => (isExpanded ? 'solid' : 'none')};
`;
export default SelectedCountryWrapper;
